import axios from 'axios';
import { getAuthToken } from '../services/auth';
import baseUrl from '../config/baseURL';

export const getFacebookComments = async (
  organization_id: any,
  account_id: any,
  nextUrl: any = null,
) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = nextUrl
          ? nextUrl
          : `${baseUrl}/core/organizations/${organization_id}/facebook-comments/`;

        console.log('Fetching Facebook comments from endpoint:', endpoint);

        const response = await axios.get(endpoint, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error('Data retrieval failed:', response);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('Unexpected API error:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred:', error);
    return { success: false, data: undefined };
  }
};

export const replyToFacebookComment = async (
  organization_id: any,
  account_id: any,
  comment_id: any,
  text: string,
) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/facebook-comments/${comment_id}/reply/`;
        const response = await axios.post(endpoint, { text }, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        }
        return { success: false, data: response?.data };
      } catch (error) {
        console.error('Unexpected reply error:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred:', error);
    return { success: false, data: undefined };
  }
};

export const deleteFacebookComment = async (
  organization_id: any,
  account_id: any,
  comment_id: any,
) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/facebook-comments/${comment_id}/`;
        const response = await axios.delete(endpoint, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        }
        return { success: false, data: response?.data };
      } catch (error) {
        console.error('Unexpected reply error:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred:', error);
    return { success: false, data: undefined };
  }
};

export const toggleFacebookAiCommentResponses = async (
  organization_id: any,
  page_id: any,
  enabled: boolean,
) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/facebook-account/${page_id}/toggle-ai-comments/`;
        const response = await axios.post(endpoint, { enabled }, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        }
        return { success: false, data: response?.data };
      } catch (error) {
        console.error('Unexpected error (toggle comment AI):', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred:', error);
    return { success: false, data: undefined };
  }
};
